import classnames from 'classnames';
import './section.scss';

interface SectionProps {
  backgroundImage?: string;
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
}
export default function Section({ title, description, children, backgroundImage, className }: SectionProps) {
  return <div className={classnames("ai-section-wrapper", className)} style={{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none' }}>
    <div className="ai-section-inner">
      <div className="ai-section-top">
        <div className="ai-section-title">{title}</div>
        <div className="ai-section-desc">{description}</div>
      </div>
    </div>
    {children}
  </div>
}